<template>
  <v-dialog :value="show" max-width="400px" persistent>
    <v-card class="rounded-lg grey lighten-4">
      <v-card-title class="pt-4 px-8 pb-0 d-flex justify-space-between">
        <span class="text-h5 font-weight-medium">{{ $t('coupon.title') }}</span>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4 px-8">
        <v-form ref="form" @submit.prevent="submitCoupon">
          <v-text-field
            v-model="couponCode"
            :label="$t('coupon.title')"
            :rules="[rules.required]"
            :error-messages="errorMessage"
            :loading="loading"
            :disabled="loading"
            outlined
            dense
            autocomplete="off"
            @input="errorMessage = ''"
          />
        </v-form>
      </v-card-text>

      <v-card-actions class="d-flex flex-column px-8 pb-4">
        <v-btn
          rounded
          block
          :loading="loading"
          :disabled="!couponCode && couponCode.length > 3"
          depressed
          :color="couponCode && couponCode.length > 3 ? '#2979FF' : 'grey lighten-2'"
          :dark="!!couponCode && couponCode.length > 3"
          height="44"
          class="text-none mb-4"
          @click="submitCoupon"
        >
          {{ $t('coupon.activateCoupon') }}
        </v-btn>
        <v-btn rounded block :disabled="loading" depressed height="44" class="text-none" color="white" @click="close">
          {{ $t('buttons.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CouponDialog',

  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      couponCode: '',
      loading: false,
      errorMessage: '',
      rules: {
        required: (v) => Boolean(v) || this.$t('coupon.required'),
      },
    };
  },

  computed: {
    primaryColor() {
      return this.$store.state.primaryColor;
    },
  },

  methods: {
    close() {
      this.$emit('update:show', false);
      this.couponCode = '';
      this.errorMessage = '';
    },
    async submitCoupon() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.errorMessage = '';

      try {
        const result = await this.$store.dispatch('calculateCouponRedemptions', {
          couponCode: this.couponCode,
        });

        if (result.success) {
          this.$store.commit('setCalculateCouponRedemptionID', result.redemptionUUID);
          this.$store.commit('setActiveCoupon', result.couponUUID);
          this.$emit('coupon-applied', result);
          this.close();
        } else {
          this.errorMessage = this.$t('coupon.errors.doesNotExist');
        }
      } catch (error) {
        this.errorMessage = this.$t('coupon.errors.unableToApply');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
